import Vue from 'vue/dist/vue.esm'
import store from './store'

import jobCategory from './components/job_category.vue'
import jobCategoryModal from './components/job_category_modal.vue'

var vms = []

// Turbolinksの読み込みイベント発生時のマウント処理
document.addEventListener('DOMContentLoaded', () => {

  if( document.querySelector('#js-vue-root') === null ) return

  const vm = new Vue({
    el: '#js-vue-root',
    store,
    components: {
      jobCategory,
      jobCategoryModal,
    },
  })
  vms.push(vm)
})

// Turbolinksの遷移イベント発生時のアンマウント処理
document.addEventListener('turbolinks:visit', () => {
  for (let vm of vms) {
    vm.$destroy()
  }
  vms = []
})